/**
 * USD label for marketplace product prices ($ always before the amount).
 */
export default function formatProductPrice(price) {
    if (price === null || price === undefined || price === '') {
        return '';
    }

    const amount = Number(price);

    if (Number.isNaN(amount)) {
        return '';
    }

    return '$' + amount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}
